import { TreeSelect as AntdTreeSelect, Typography, Form } from 'antd'
const { TreeNode } = AntdTreeSelect

const getTreeNode = data => (
  <>
    {data?.map(item => {
      if (item.children) {
        return (
          <TreeNode
            value={item?.id}
            key={item.id}
            name={item?.name}
            title={<RenderTreeItem node={item} />}
          >
            {getTreeNode(item.children)}
          </TreeNode>
        )
      } else {
        return (
          <TreeNode
            value={item?.id}
            name={item?.name}
            key={item.id}
            title={<RenderTreeItem node={item} />}
          />
        )
      }
    })}
  </>
)
const TreeData = data =>
  data.map(item => {
    if (item.children) {
      return (
        <AntdTreeSelect.TreeNode
          value={item?.id}
          title={<RenderTreeItem node={item} />}
          key={item?.id}
        >
          {TreeData(item.children)}
        </AntdTreeSelect.TreeNode>
      )
    }
    return (
      <AntdTreeSelect.TreeNode
        value={item?.id}
        key={item?.id}
        title={<RenderTreeItem node={item} />}
      />
    )
  })
const RenderTreeItem = props => {
  const { node } = props
  return (
    <div
      style={{
        display: 'flex',
        fontSize: 14,
      }}
    >
      <Typography.Text
        ellipsis={{ tooltip: { getPopupContainer: () => document.body } }}
        style={{ maxWidth: 200 }}
      >
        {node.name}{' '}
        <span style={{ marginLeft: 5 }}>
          (<span style={{ color: '#2090a8' }}>{node.total}</span>)
        </span>
      </Typography.Text>
    </div>
  )
}

export const STreeSelect = ({ option, style, onChange, ...props }) => (
  <>
    <Form.Item name={option?.name}>
      <AntdTreeSelect
        placeholder={option?.label}
        allowClear={typeof option?.allowClear === 'boolean' ? option?.allowClear : true}
        showSearch
        showArrow
        style={style}
        maxTagTextLength={5}
        maxTagCount={option?.maxLength ? option?.maxLength : 1}
        getPopupContainer={(node: any) =>
          node.parentNode?.parentNode?.parentNode?.parentNode?.parentNode?.parentNode?.parentNode
            ?.parentNode || document.body
        }
        onChange={(_, e) => onChange(e)}
        treeCheckable
        // treeNodeLabelProp={'name'}
        treeData={option?.data}
      >
        {getTreeNode(option?.data)}
      </AntdTreeSelect>
    </Form.Item>
  </>
)
